import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BehaviorSubject, Observable, distinctUntilChanged, fromEvent, map, merge, takeUntil } from 'rxjs';
import { MatFormFieldControlImpl } from '../../ng-material-impl/mat-form-field-control.impl';
import { TextAreaFormControlService } from '../text-area-form-control.service';

@Component({
  selector: 'ss-text-area-control',
  templateUrl: './text-area-control.component.html',
  styleUrls: ['./text-area-control.component.css'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: TextAreaControlComponent
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaControlComponent extends MatFormFieldControlImpl<string> implements OnInit {

  @ViewChild('textAreaRef', { read: ElementRef })
  private _textAreaRef!: ElementRef<HTMLTextAreaElement>

  readonly MIN_HEIGHT = 50;

  readonly valueSubject = this._formControlService.valueSubject;
  readonly heightSubject = new BehaviorSubject<string>('');
  readonly readOnlyObs = this._formControlService.readOnlyObs

  readonly minRowsSubject = this._textAreaFormControlService.minRowsSubject
  readonly maxRowsSubject = this._textAreaFormControlService.maxRowsSubject


  constructor(
    private readonly _textAreaFormControlService: TextAreaFormControlService
  ) {

    super('text')
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    this._formControlService.htmlElementSubject.next(this._textAreaRef.nativeElement);
    const changeObs = fromEvent(this._textAreaRef.nativeElement, 'change')

    const inputKeyStream = fromEvent(this._textAreaRef.nativeElement, 'keyup') as Observable<KeyboardEvent>

    merge(inputKeyStream, changeObs)
      .pipe(
        map((evParams) => {
          const htmlInputElement = evParams.target as HTMLInputElement;
          const value = htmlInputElement.value;
          return value;
        }),
        distinctUntilChanged(),
        takeUntil(this._destroy),
      )
      .subscribe((value) => {


        this.valueSubject.next(value);

      })


    this.valueSubject
      .pipe(
        takeUntil(this._destroy),
        map((value) => {
          const textArea = this._textAreaRef.nativeElement;
          const scrollHeight = textArea.scrollHeight;
          return scrollHeight;
        }),
        distinctUntilChanged()
      )
      .subscribe((height) => this.heightSubject.next(height / 10 + 'rem'))
  }

  onContainerClick(event: MouseEvent): void {
    this._textAreaRef.nativeElement.focus();
  }

}
